import { Box } from "@mui/material";
import { Form, Field } from "react-final-form";
import Button from "../../../components/Button";
import { InputText } from "../../../components/Input";
import { PostProcesosProductivoArea } from "../../../services/productServices";

const AddMotivoPausaOtg = ({ setAlertCustom, refetch }) => {
  const obj: any = {};
  return (
    <Form
      onSubmit={(values) => {
        PostProcesosProductivoArea({
          ...values,
          procesoProductivoTipoActivo: 1,
        })
          .then(() => {
            setAlertCustom({
              open: true,
              title: "Confirmacion",
              severity: "success",
              message: "Se guardo correctamente",
            });
            obj.funcion();
            refetch();
          })
          .catch((error) => {
            setAlertCustom({
              open: true,
              title: "Error",
              severity: "error",
              message: error?.message,
            });
          });
      }}
      initialValues={{}}
      render={({
        handleSubmit,
        form: { restart },
        submitting,
        pristine,
        values,
      }) => {
        obj.funcion = restart;
        return (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            <Box className="col-12">
              <Field
                component={InputText as any}
                name={"procesoProductivoTipoDescripcion"}
                label={"Motivo de pausa"}
                sx={{ width: "100%" }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 3,
              }}
              className="col-12"
            >
              <Button
                label={"Crear motivo de pausa"}
                onClick={handleSubmit}
                sx={{ minWidth: "150px" }}
                color="success"
              />
            </Box>
          </Box>
        );
      }}
    />
  );
};
export default AddMotivoPausaOtg;
